// extracted by mini-css-extract-plugin
export default {"details":"_3VU6rwt9XO","code-editor":"_2gPnKIU9Wp","codeEditor":"_2gPnKIU9Wp","event-type":"_2RhjVEkE5u","eventType":"_2RhjVEkE5u","event-description":"W3SFQ6Ekdk","eventDescription":"W3SFQ6Ekdk"};
    if(module.hot) {
      // 1627035632787
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  